import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getScheduleTemplate = async () => {
  const { data } = await SigliveServiceV1({
    method: 'GET',
    url: `schedule/template`,
    responseType: 'blob',
  });

  return data;
};

export default getScheduleTemplate;
